// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `search-panel {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  z-index: 99;
}
search-panel a:hover {
  text-decoration: none !important;
}
search-panel .content .result-info {
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
search-panel .content .results {
  display: flex;
  flex-direction: column;
}
search-panel .content .results .result-item {
  margin-top: 16px;
  border-radius: 4px;
}
search-panel .content .results .result-item .title {
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
}
search-panel .content .results .result-item .url {
  margin-bottom: 4px;
}
search-panel .content .results .result-item .excerpt {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}
search-panel .content .results .result-item:last-child {
  margin-bottom: 32px;
}
search-panel .content .simple-pagination {
  margin: 32px 0;
}

.search-panel {
  margin-top: 64px;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
}
@media screen and (max-width: 599px) {
  .search-panel {
    margin-top: 56px;
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
  }
}
@media screen and (min-width: 1280px) {
  .search-panel {
    width: calc(100% - 280px);
    min-width: calc(100% - 280px);
    max-width: calc(100% - 280px);
  }
}

.commercial-tile {
  /* Card appearance */
  border: 1px solid #e0e0e0;
  border-left: 5px solid #0056b3;
  border-radius: 6px;
  padding: 12px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;
  /* --- HEADER/ACTION ROW --- */
  /* --- CORE DATA GRID (Reference and Price) --- */
  /* --- SECONDARY DETAILS (CHIPS) --- */
}
.commercial-tile:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}
.commercial-tile .tile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9em;
  color: #616161;
  margin-bottom: 10px;
}
.commercial-tile .tile-header .property-type-label {
  display: flex;
  align-items: center;
}
.commercial-tile .tile-header .property-type-label .icon-type {
  margin-right: 4px;
  font-size: 18px;
  color: #78909c;
}
.commercial-tile .tile-header .icon-archived {
  color: #ef5350;
  margin-left: auto;
  margin-right: 10px;
}
.commercial-tile .core-data-link {
  text-decoration: none;
  color: inherit;
}
.commercial-tile .core-data-link .data-grid {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #e0e0e0;
  margin-bottom: 10px;
}
.commercial-tile .core-data-link .data-grid .ref-container .data-label {
  font-size: 0.75em;
  color: #9e9e9e;
  display: block;
}
.commercial-tile .core-data-link .data-grid .ref-container .property-reference {
  font-size: 1.2em;
  font-weight: 700;
  color: #0056b3;
  margin: 0;
}
.commercial-tile .core-data-link .data-grid .price-container {
  text-align: right;
}
.commercial-tile .core-data-link .data-grid .price-container .price-value {
  font-size: 1.2em;
  font-weight: 600;
  display: block;
}
.commercial-tile .secondary-details {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.commercial-tile .secondary-details .detail-chip {
  font-size: 0.75em;
  padding: 3px 8px;
  border-radius: 4px;
  font-weight: 500;
  white-space: nowrap;
}
.commercial-tile .secondary-details .detail-chip.location-chip {
  background-color: #e3f2fd;
  color: #1565c0;
}
.commercial-tile .secondary-details .detail-chip.type-chip {
  background-color: #fce4ec;
  color: #ad1457;
}
.commercial-tile .secondary-details .detail-chip.subtype-chip {
  background-color: #e0f7fa;
  color: #00838f;
}

.dossier-tile {
  /* Similar card structure to the property, but different color stripe */
  border: 1px solid #e0e0e0;
  border-left: 5px solid #673ab7;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 15px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;
  /* --- HEADER/ACTION ROW --- */
  /* --- CORE DATA GROUP --- */
  /* --- SECONDARY DETAILS (CHIPS) --- */
}
.dossier-tile:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.dossier-tile .tile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9em;
  color: #616161;
  margin-bottom: 8px;
}
.dossier-tile .tile-header .dossier-model-label {
  display: flex;
  align-items: center;
}
.dossier-tile .tile-header .dossier-model-label .icon-type {
  margin-right: 4px;
  font-size: 18px;
  color: #673ab7;
}
.dossier-tile .tile-header .dossier-model-label span {
  font-weight: 500;
}
.dossier-tile .tile-header .icon-archived {
  color: #ef5350;
  margin-left: auto;
  margin-right: 10px;
}
.dossier-tile .core-data-link {
  text-decoration: none;
  color: inherit;
  display: block;
  padding-bottom: 8px;
  border-bottom: 1px dashed #e0e0e0;
  margin-bottom: 10px;
}
.dossier-tile .core-data-link .data-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.dossier-tile .core-data-link .data-group .id-container {
  margin-bottom: 4px;
}
.dossier-tile .core-data-link .data-group .id-container .data-label {
  font-size: 0.75em;
  color: #9e9e9e;
  display: block;
}
.dossier-tile .core-data-link .data-group .id-container .dossier-id {
  font-size: 1.2em;
  font-weight: 700;
  color: #4527a0;
  margin: 0;
}
.dossier-tile .core-data-link .data-group .description-container .dossier-description {
  font-size: 0.95em;
  color: #424242;
  margin: 0;
  overflow: hidden;
  display: -webkit-box;
}
.dossier-tile .secondary-details {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.dossier-tile .secondary-details .detail-chip {
  font-size: 0.75em;
  padding: 3px 8px;
  border-radius: 4px;
  font-weight: 500;
  white-space: nowrap;
}
.dossier-tile .secondary-details .detail-chip.status-chip {
  background-color: #ede7f6;
  color: #512da8;
}
.dossier-tile .secondary-details .detail-chip.purpose-chip {
  background-color: #e8f5e9;
  color: #2e7d32;
}
.dossier-tile .secondary-details .detail-chip.cost-chip.price-sale {
  background-color: #fff3e0;
  color: #e65100;
}
.dossier-tile .secondary-details .detail-chip.cost-chip.price-cost {
  background-color: #ffebee;
  color: #c62828;
}

.activity-tile {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 15px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;
  /* --- TYPE VARIANTS --- */
  /* --- HEADER/ACTION ROW --- */
  /* --- CORE DATA GROUP --- */
  /* --- SECONDARY DETAILS --- */
}
.activity-tile:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.activity-tile.is-task {
  border-left: 5px solid #388e3c;
}
.activity-tile.is-task .icon-type {
  color: #388e3c;
}
.activity-tile.is-meeting {
  border-left: 5px solid #1976d2;
}
.activity-tile.is-meeting .icon-type {
  color: #1976d2;
}
.activity-tile .tile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9em;
  color: #616161;
  margin-bottom: 8px;
}
.activity-tile .tile-header .activity-type-label {
  display: flex;
  align-items: center;
}
.activity-tile .tile-header .activity-type-label .icon-type {
  margin-right: 4px;
  font-size: 18px;
}
.activity-tile .tile-header .activity-type-label .model-text {
  font-weight: 500;
  margin-right: 6px;
}
.activity-tile .tile-header .activity-type-label .type-badge {
  margin-left: 8px;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 0.65em;
  font-weight: 700;
  background-color: #e0e0e0;
  color: #424242;
}
.activity-tile .core-data-link {
  text-decoration: none;
  color: inherit;
  display: block;
  padding-bottom: 8px;
  border-bottom: 1px dashed #e0e0e0;
  margin-bottom: 10px;
}
.activity-tile .core-data-link .data-group .activity-subject {
  font-size: 1.25em;
  font-weight: 600;
  color: #212121;
  margin: 0 0 6px 0;
}
.activity-tile .core-data-link .data-group .date-time-container {
  font-size: 0.9em;
  color: #424242;
}
.activity-tile .core-data-link .data-group .date-time-container .data-label {
  font-weight: 700;
  margin-right: 4px;
  color: #757575;
}
.activity-tile .core-data-link .data-group .date-time-container .time-value {
  font-weight: 500;
  margin-left: 8px;
}
.activity-tile .secondary-details {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.activity-tile .secondary-details .detail-chip {
  font-size: 0.75em;
  padding: 3px 8px;
  border-radius: 4px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
}
.activity-tile .secondary-details .detail-chip.status-chip.is-task {
  background-color: #e8f5e9;
  color: #2e7d32;
}
.activity-tile .secondary-details .detail-chip.status-chip.is-meeting {
  background-color: #e3f2fd;
  color: #1565c0;
}
.activity-tile .secondary-details .detail-chip.participant-chip {
  background-color: #e8f5e9;
  color: #2e7d32;
}
.activity-tile .secondary-details .detail-chip.email-chip {
  background-color: #fbe9e7;
  color: #d84315;
}
.activity-tile .secondary-details .detail-chip mat-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
  margin-right: 4px;
}

.client-tile {
  border: 1px solid #e0e0e0;
  border-left: 5px solid #ff9800;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 15px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  /* --- HEADER/ID ROW --- */
  /* --- CORE DATA GROUP (Name & Contact) --- */
  /* --- SECONDARY DETAILS (Chips) --- */
}
.client-tile .tile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9em;
  color: #616161;
  margin-bottom: 8px;
}
.client-tile .tile-header .client-model-label {
  display: flex;
  align-items: center;
}
.client-tile .tile-header .client-model-label .icon-type {
  margin-right: 4px;
  font-size: 18px;
  color: #ff9800;
}
.client-tile .tile-header .client-model-label .model-text {
  font-weight: 500;
}
.client-tile .tile-header .client-model-label .type-badge {
  margin-left: 8px;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 0.65em;
  font-weight: 700;
  background-color: #fff3e0;
  color: #e65100;
}
.client-tile .tile-header .icon-archived {
  color: #ef5350;
  margin-left: auto;
  margin-right: 10px;
}
.client-tile .tile-header .client-id-ref {
  font-size: 0.8em;
  color: #757575;
  margin-left: auto;
  margin-right: 12px;
}
.client-tile .core-data-link {
  text-decoration: none;
  color: inherit;
  display: block;
  padding-bottom: 8px;
  border-bottom: 1px dashed #e0e0e0;
  margin-bottom: 10px;
}
.client-tile .core-data-link .data-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.client-tile .core-data-link .data-group .id-container .data-label {
  font-size: 0.75em;
  color: #9e9e9e;
  display: block;
}
.client-tile .core-data-link .data-group .id-container .client-id {
  font-size: 1.4em;
  font-weight: 700;
  color: #212121;
  margin: 0;
}
.client-tile .core-data-link .data-group .description-container .client-description {
  font-size: 1em;
  color: #424242;
  margin: 0;
}
.client-tile .secondary-details {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.client-tile .secondary-details .detail-chip {
  font-size: 0.75em;
  padding: 3px 8px;
  border-radius: 4px;
  font-weight: 500;
  white-space: nowrap;
}
.client-tile .secondary-details .detail-chip.status-chip {
  background-color: #e0f7fa;
  color: #00838f;
}
.client-tile .secondary-details .detail-chip.type-chip {
  background-color: #f3e5f5;
  color: #880e4f;
}
.client-tile .secondary-details .detail-chip.id-chip {
  background-color: #f5f5f5;
  color: #616161;
  font-family: monospace;
}

.action-link {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/search-panel/search-panel.component.scss","webpack://./src/@fuse/scss/partials/_breakpoints.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AAFJ;AAGI;EACI,gCAAA;AADR;AAIQ;EACI,oBAAA;EACA,4CAAA;AAFZ;AAKQ;EACI,aAAA;EACA,sBAAA;AAHZ;AAKY;EACI,gBAAA;EACA,kBAAA;AAHhB;AAKgB;EACI,eAAA;EACA,gBAAA;EACA,eAAA;AAHpB;AAMgB;EACI,kBAAA;AAJpB;AAOgB;EACI,cAAA;EACA,gBAAA;EACA,uBAAA;AALpB;AAQgB;EACI,mBAAA;AANpB;AAWQ;EACI,cAAA;AATZ;;AAcA;EACI,gBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAXJ;AChBQ;EDuBR;IAOQ,gBAAA;IACA,sBAAA;IACA,0BAAA;IACA,0BAAA;EAVN;AACF;ACxBQ;EDuBR;IAcQ,yBAAA;IACA,6BAAA;IACA,6BAAA;EATN;AACF;;AAWA;EACI,oBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,aAAA;EAEA,yBAAA;EACA,yCAAA;EACA,gCAAA;EAOA,8BAAA;EA2BA,iDAAA;EAyCA,sCAAA;AAjFJ;AAQI;EACI,yCAAA;EACA,2BAAA;AANR;AAUI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AARR;AAUQ;EACI,aAAA;EACA,mBAAA;AARZ;AAUY;EACI,iBAAA;EACA,eAAA;EACA,cAAA;AARhB;AAYQ;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;AAVZ;AAeI;EACI,qBAAA;EACA,cAAA;AAbR;AAeQ;EACI,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,iCAAA;EACA,mBAAA;AAbZ;AAgBgB;EACI,iBAAA;EACA,cAAA;EACA,cAAA;AAdpB;AAiBgB;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAfpB;AAmBY;EACI,iBAAA;AAjBhB;AAmBgB;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;AAjBpB;AAwBI;EACI,aAAA;EACA,eAAA;EACA,QAAA;AAtBR;AAwBQ;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAtBZ;AAwBY;EACI,yBAAA;EACA,cAAA;AAtBhB;AAwBY;EACI,yBAAA;EACA,cAAA;AAtBhB;AAwBY;EACI,yBAAA;EACA,cAAA;AAtBhB;;AA4BA;EACI,uEAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;EACA,gCAAA;EAMA,8BAAA;EA+BA,4BAAA;EA2CA,sCAAA;AAtGJ;AAwBI;EACI,yCAAA;AAtBR;AA0BI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAxBR;AA0BQ;EACI,aAAA;EACA,mBAAA;AAxBZ;AA0BY;EACI,iBAAA;EACA,eAAA;EACA,cAAA;AAxBhB;AA2BY;EACI,gBAAA;AAzBhB;AA6BQ;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;AA3BZ;AAgCI;EACI,qBAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,iCAAA;EACA,mBAAA;AA9BR;AAgCQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AA9BZ;AAgCY;EACI,kBAAA;AA9BhB;AAgCgB;EACI,iBAAA;EACA,cAAA;EACA,cAAA;AA9BpB;AAiCgB;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA/BpB;AAoCgB;EACI,iBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AAlCpB;AAyCI;EACI,aAAA;EACA,eAAA;EACA,QAAA;AAvCR;AAyCQ;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAvCZ;AAyCY;EACI,yBAAA;EACA,cAAA;AAvChB;AA0CY;EACI,yBAAA;EACA,cAAA;AAxChB;AA4CgB;EACI,yBAAA;EACA,cAAA;AA1CpB;AA6CgB;EACI,yBAAA;EACA,cAAA;AA3CpB;;AAiDA;EACI,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;EACA,gCAAA;EAMA,0BAAA;EAiBA,8BAAA;EAmCA,4BAAA;EAmCA,8BAAA;AAvIJ;AA4CI;EACI,yCAAA;AA1CR;AA8CI;EACI,8BAAA;AA5CR;AA8CQ;EACI,cAAA;AA5CZ;AAgDI;EACI,8BAAA;AA9CR;AAgDQ;EACI,cAAA;AA9CZ;AAmDI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAjDR;AAmDQ;EACI,aAAA;EACA,mBAAA;AAjDZ;AAmDY;EACI,iBAAA;EACA,eAAA;AAjDhB;AAoDY;EACI,gBAAA;EACA,iBAAA;AAlDhB;AAqDY;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AAnDhB;AAyDI;EACI,qBAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,iCAAA;EACA,mBAAA;AAvDR;AA0DY;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAxDhB;AA2DY;EACI,gBAAA;EACA,cAAA;AAzDhB;AA2DgB;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;AAzDpB;AA4DgB;EACI,gBAAA;EACA,gBAAA;AA1DpB;AAiEI;EACI,aAAA;EACA,eAAA;EACA,QAAA;AA/DR;AAiEQ;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AA/DZ;AAkEgB;EACI,yBAAA;EACA,cAAA;AAhEpB;AAkEgB;EACI,yBAAA;EACA,cAAA;AAhEpB;AAoEY;EACI,yBAAA;EACA,cAAA;AAlEhB;AAqEY;EACI,yBAAA;EACA,cAAA;AAnEhB;AAsEY;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AApEhB;;AA0EA;EACI,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;EAEA,0BAAA;EAgDA,6CAAA;EAuCA,sCAAA;AA7JJ;AAuEI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AArER;AAuEQ;EACI,aAAA;EACA,mBAAA;AArEZ;AAuEY;EACI,iBAAA;EACA,eAAA;EACA,cAAA;AArEhB;AAwEY;EACI,gBAAA;AAtEhB;AAyEY;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AAvEhB;AA2EQ;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;AAzEZ;AA4EQ;EACI,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AA1EZ;AA+EI;EACI,qBAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,iCAAA;EACA,mBAAA;AA7ER;AA+EQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AA7EZ;AAgFgB;EACI,iBAAA;EACA,cAAA;EACA,cAAA;AA9EpB;AAiFgB;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA/EpB;AAoFgB;EACI,cAAA;EACA,cAAA;EACA,SAAA;AAlFpB;AAyFI;EACI,aAAA;EACA,eAAA;EACA,QAAA;AAvFR;AAyFQ;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAvFZ;AAyFY;EACI,yBAAA;EACA,cAAA;AAvFhB;AA0FY;EACI,yBAAA;EACA,cAAA;AAxFhB;AA2FY;EACI,yBAAA;EACA,cAAA;EACA,sBAAA;AAzFhB;;AA+FA;EACI,eAAA;AA5FJ","sourcesContent":["@use '@angular/material' as mat;\n@import 'src/@fuse/scss/fuse';\n\nsearch-panel {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    width: 100%;\n    min-width: 100%;\n    max-width: 100%;\n    z-index: 99;\n    a:hover {\n        text-decoration: none !important;\n    }\n    .content {\n        .result-info {\n            padding-bottom: 16px;\n            border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n        }\n\n        .results {\n            display: flex;\n            flex-direction: column;\n\n            .result-item {\n                margin-top: 16px;\n                border-radius: 4px;\n\n                .title {\n                    font-size: 17px;\n                    font-weight: 600;\n                    cursor: pointer;\n                }\n\n                .url {\n                    margin-bottom: 4px;\n                }\n\n                .excerpt {\n                    display: block;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                }\n\n                &:last-child {\n                    margin-bottom: 32px;\n                }\n            }\n        }\n\n        .simple-pagination {\n            margin: 32px 0;\n        }\n    }\n}\n\n.search-panel {\n    margin-top: 64px;\n    width: 100%;\n    min-width: 100%;\n    max-width: 100%;\n\n    @include media-breakpoint('xs') {\n        margin-top: 56px;\n        width: 100% !important;\n        min-width: 100% !important;\n        max-width: 100% !important;\n    }\n\n    @include media-breakpoint('gt-md') {\n        width: calc(100% - 280px);\n        min-width: calc(100% - 280px);\n        max-width: calc(100% - 280px);\n    }\n}\n.commercial-tile {\n    /* Card appearance */\n    border: 1px solid #e0e0e0;\n    border-left: 5px solid #0056b3; // Feature stripe for quick visual identification\n    border-radius: 6px;\n    padding: 12px;\n    // margin-bottom: 15px;\n    background-color: #ffffff;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n    transition: all 0.2s ease-in-out;\n\n    &:hover {\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n        transform: translateY(-2px); // Slight lift on hover\n    }\n\n    /* --- HEADER/ACTION ROW --- */\n    .tile-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-size: 0.9em;\n        color: #616161;\n        margin-bottom: 10px;\n\n        .property-type-label {\n            display: flex;\n            align-items: center;\n\n            .icon-type {\n                margin-right: 4px;\n                font-size: 18px;\n                color: #78909c; // Subtle icon color\n            }\n        }\n\n        .icon-archived {\n            color: #ef5350; // Red for archived status\n            margin-left: auto;\n            margin-right: 10px;\n        }\n    }\n\n    /* --- CORE DATA GRID (Reference and Price) --- */\n    .core-data-link {\n        text-decoration: none;\n        color: inherit;\n\n        .data-grid {\n            display: flex;\n            justify-content: space-between;\n            align-items: flex-start;\n            gap: 10px;\n            padding-bottom: 8px;\n            border-bottom: 1px dashed #e0e0e0;\n            margin-bottom: 10px;\n\n            .ref-container {\n                .data-label {\n                    font-size: 0.75em;\n                    color: #9e9e9e; // Light grey label\n                    display: block;\n                }\n\n                .property-reference {\n                    font-size: 1.2em;\n                    font-weight: 700;\n                    color: #0056b3; // Dark teal for reference number\n                    margin: 0;\n                }\n            }\n\n            .price-container {\n                text-align: right;\n\n                .price-value {\n                    font-size: 1.2em;\n                    font-weight: 600;\n                    display: block;\n                }\n            }\n        }\n    }\n\n    /* --- SECONDARY DETAILS (CHIPS) --- */\n    .secondary-details {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 6px;\n\n        .detail-chip {\n            font-size: 0.75em;\n            padding: 3px 8px;\n            border-radius: 4px;\n            font-weight: 500;\n            white-space: nowrap;\n\n            &.location-chip {\n                background-color: #e3f2fd;\n                color: #1565c0;\n            }\n            &.type-chip {\n                background-color: #fce4ec;\n                color: #ad1457;\n            }\n            &.subtype-chip {\n                background-color: #e0f7fa; // Light cyan\n                color: #00838f;\n            }\n        }\n    }\n}\n\n.dossier-tile {\n    /* Similar card structure to the property, but different color stripe */\n    border: 1px solid #e0e0e0;\n    border-left: 5px solid #673ab7; // Purple stripe for Dossier model\n    border-radius: 6px;\n    padding: 12px;\n    margin-bottom: 15px;\n    background-color: #ffffff;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n    transition: all 0.2s ease-in-out;\n\n    &:hover {\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    }\n\n    /* --- HEADER/ACTION ROW --- */\n    .tile-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-size: 0.9em;\n        color: #616161;\n        margin-bottom: 8px;\n\n        .dossier-model-label {\n            display: flex;\n            align-items: center;\n\n            .icon-type {\n                margin-right: 4px;\n                font-size: 18px;\n                color: #673ab7; // Match purple stripe\n            }\n\n            span {\n                font-weight: 500;\n            }\n        }\n\n        .icon-archived {\n            color: #ef5350; // Red for archived\n            margin-left: auto;\n            margin-right: 10px;\n        }\n    }\n\n    /* --- CORE DATA GROUP --- */\n    .core-data-link {\n        text-decoration: none;\n        color: inherit;\n        display: block;\n        padding-bottom: 8px;\n        border-bottom: 1px dashed #e0e0e0;\n        margin-bottom: 10px;\n\n        .data-group {\n            display: flex;\n            flex-direction: column;\n            gap: 4px;\n\n            .id-container {\n                margin-bottom: 4px;\n\n                .data-label {\n                    font-size: 0.75em;\n                    color: #9e9e9e;\n                    display: block;\n                }\n\n                .dossier-id {\n                    font-size: 1.2em;\n                    font-weight: 700;\n                    color: #4527a0; // Darker purple for ID\n                    margin: 0;\n                }\n            }\n\n            .description-container {\n                .dossier-description {\n                    font-size: 0.95em;\n                    color: #424242; // Dark grey for easy reading\n                    margin: 0;\n                    overflow: hidden;\n                    display: -webkit-box;\n                }\n            }\n        }\n    }\n\n    /* --- SECONDARY DETAILS (CHIPS) --- */\n    .secondary-details {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 6px;\n\n        .detail-chip {\n            font-size: 0.75em;\n            padding: 3px 8px;\n            border-radius: 4px;\n            font-weight: 500;\n            white-space: nowrap;\n\n            &.status-chip {\n                background-color: #ede7f6; // Light purple\n                color: #512da8;\n            }\n\n            &.purpose-chip {\n                background-color: #e8f5e9; // Light green\n                color: #2e7d32;\n            }\n\n            &.cost-chip {\n                &.price-sale {\n                    background-color: #fff3e0; // Light orange for Sale\n                    color: #e65100;\n                }\n\n                &.price-cost {\n                    background-color: #ffebee; // Light red for Cost\n                    color: #c62828;\n                }\n            }\n        }\n    }\n}\n.activity-tile {\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    padding: 12px;\n    margin-bottom: 15px;\n    background-color: #ffffff;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n    transition: all 0.2s ease-in-out;\n\n    &:hover {\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    }\n\n    /* --- TYPE VARIANTS --- */\n    &.is-task {\n        border-left: 5px solid #388e3c; // Green for Task/Completion\n\n        .icon-type {\n            color: #388e3c;\n        }\n    }\n\n    &.is-meeting {\n        border-left: 5px solid #1976d2; // Blue for Meeting/Calendar\n\n        .icon-type {\n            color: #1976d2;\n        }\n    }\n\n    /* --- HEADER/ACTION ROW --- */\n    .tile-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-size: 0.9em;\n        color: #616161;\n        margin-bottom: 8px;\n\n        .activity-type-label {\n            display: flex;\n            align-items: center;\n\n            .icon-type {\n                margin-right: 4px;\n                font-size: 18px;\n            }\n\n            .model-text {\n                font-weight: 500;\n                margin-right: 6px;\n            }\n\n            .type-badge {\n                margin-left: 8px;\n                padding: 2px 6px;\n                border-radius: 3px;\n                font-size: 0.65em;\n                font-weight: 700;\n                background-color: #e0e0e0;\n                color: #424242;\n            }\n        }\n    }\n\n    /* --- CORE DATA GROUP --- */\n    .core-data-link {\n        text-decoration: none;\n        color: inherit;\n        display: block;\n        padding-bottom: 8px;\n        border-bottom: 1px dashed #e0e0e0;\n        margin-bottom: 10px;\n\n        .data-group {\n            .activity-subject {\n                font-size: 1.25em;\n                font-weight: 600;\n                color: #212121;\n                margin: 0 0 6px 0;\n            }\n\n            .date-time-container {\n                font-size: 0.9em;\n                color: #424242;\n\n                .data-label {\n                    font-weight: 700;\n                    margin-right: 4px;\n                    color: #757575;\n                }\n\n                .time-value {\n                    font-weight: 500;\n                    margin-left: 8px;\n                }\n            }\n        }\n    }\n\n    /* --- SECONDARY DETAILS --- */\n    .secondary-details {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 6px;\n\n        .detail-chip {\n            font-size: 0.75em;\n            padding: 3px 8px;\n            border-radius: 4px;\n            font-weight: 500;\n            display: inline-flex;\n            align-items: center;\n\n            &.status-chip {\n                &.is-task {\n                    background-color: #e8f5e9; // Light green\n                    color: #2e7d32;\n                }\n                &.is-meeting {\n                    background-color: #e3f2fd;\n                    color: #1565c0;\n                }\n            }\n\n            &.participant-chip {\n                background-color: #e8f5e9;\n                color: #2e7d32;\n            }\n\n            &.email-chip {\n                background-color: #fbe9e7;\n                color: #d84315;\n            }\n\n            mat-icon {\n                font-size: 18px;\n                height: 18px;\n                width: 18px;\n                margin-right: 4px;\n            }\n        }\n    }\n}\n\n.client-tile {\n    border: 1px solid #e0e0e0;\n    border-left: 5px solid #ff9800; // Orange stripe for Clients\n    border-radius: 6px;\n    padding: 12px;\n    margin-bottom: 15px;\n    background-color: #ffffff;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n\n    /* --- HEADER/ID ROW --- */\n    .tile-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-size: 0.9em;\n        color: #616161;\n        margin-bottom: 8px;\n\n        .client-model-label {\n            display: flex;\n            align-items: center;\n\n            .icon-type {\n                margin-right: 4px;\n                font-size: 18px;\n                color: #ff9800;\n            }\n\n            .model-text {\n                font-weight: 500;\n            }\n\n            .type-badge {\n                margin-left: 8px;\n                padding: 2px 6px;\n                border-radius: 3px;\n                font-size: 0.65em;\n                font-weight: 700;\n                background-color: #fff3e0; // Light orange\n                color: #e65100;\n            }\n        }\n\n        .icon-archived {\n            color: #ef5350; // Red for archived\n            margin-left: auto;\n            margin-right: 10px;\n        }\n\n        .client-id-ref {\n            font-size: 0.8em;\n            color: #757575;\n            margin-left: auto;\n            margin-right: 12px;\n        }\n    }\n\n    /* --- CORE DATA GROUP (Name & Contact) --- */\n    .core-data-link {\n        text-decoration: none;\n        color: inherit;\n        display: block;\n        padding-bottom: 8px;\n        border-bottom: 1px dashed #e0e0e0;\n        margin-bottom: 10px;\n\n        .data-group {\n            display: flex;\n            flex-direction: column;\n            gap: 4px;\n\n            .id-container {\n                .data-label {\n                    font-size: 0.75em;\n                    color: #9e9e9e;\n                    display: block;\n                }\n\n                .client-id {\n                    font-size: 1.4em;\n                    font-weight: 700;\n                    color: #212121;\n                    margin: 0;\n                }\n            }\n\n            .description-container {\n                .client-description {\n                    font-size: 1em;\n                    color: #424242;\n                    margin: 0;\n                }\n            }\n        }\n    }\n\n    /* --- SECONDARY DETAILS (Chips) --- */\n    .secondary-details {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 6px;\n\n        .detail-chip {\n            font-size: 0.75em;\n            padding: 3px 8px;\n            border-radius: 4px;\n            font-weight: 500;\n            white-space: nowrap;\n\n            &.status-chip {\n                background-color: #e0f7fa; // Light cyan\n                color: #00838f;\n            }\n\n            &.type-chip {\n                background-color: #f3e5f5; // Light purple/pink\n                color: #880e4f;\n            }\n\n            &.id-chip {\n                background-color: #f5f5f5;\n                color: #616161;\n                font-family: monospace;\n            }\n        }\n    }\n}\n\n.action-link {\n    cursor: pointer;\n}\n","// Media step breakpoint mixin based on Angular Material lib\n$breakpoints: (\n    xs: 'screen and (max-width: 599px)',\n    sm: 'screen and (min-width: 600px) and (max-width: 959px)',\n    md: 'screen and (min-width: 960px) and (max-width: 1279px)',\n    lg: 'screen and (min-width: 1280px) and (max-width: 1919px)',\n    xl: 'screen and (min-width: 1920px) and (max-width: 5000px)',\n    lt-sm: 'screen and (max-width: 599px)',\n    lt-md: 'screen and (max-width: 959px)',\n    lt-lg: 'screen and (max-width: 1279px)',\n    lt-xl: 'screen and (max-width: 1919px)',\n    gt-xs: 'screen and (min-width: 600px)',\n    gt-sm: 'screen and (min-width: 960px)',\n    gt-md: 'screen and (min-width: 1280px)',\n    gt-lg: 'screen and (min-width: 1920px)'\n) !default;\n\n// Re-map the breakpoints for the helper classes\n$helper-breakpoints: (\n    xs: null,\n    sm: 'gt-xs',\n    md: 'gt-sm',\n    lg: 'gt-md',\n    xl: 'gt-lg'\n);\n\n@mixin media-breakpoint($breakpointName) {\n\n    $mediaQuery: map-get($breakpoints, $breakpointName);\n\n    @if ($mediaQuery == null) {\n        @content\n    } @else {\n        @media #{$mediaQuery} {\n            @content\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
